import React from "react";
import PropTypes from "prop-types";
import ListStyled from "./List.Style";
import { applyKey } from "../../../utils";

const List = (props) => {
  const { listItems, forEach, children } = props;

  return (
    <ListStyled {...props}>
      {applyKey(listItems, (item) => (
        <li>{forEach(item)}</li>
      ))}
      {children}
    </ListStyled>
  );
};

List.defaultProps = {
  styleType: "none",
  listItems: [],
  forEach: (item) => item,
};

List.propTypes = {
  styleType: PropTypes.oneOf(["none", "disc"]),
  listItems: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  forEach: PropTypes.func,
};

export default List;
